import { CodeSection, CodeSubject } from './code-subject-section';

export const KeySubjects = {
  keyInterprete: `subject-${CodeSubject.INTERPR}`,
  keyMadre: `subject-${CodeSubject.MADRE}`,
  keyMadreBio: `subject-${CodeSubject.MADREBIO}`,
  keyPadre: `subject-${CodeSubject.PADRE}`,
  keyPadreBio: `subject-${CodeSubject.PADREBIO}`,
  keyDeceduto: `subject-${CodeSubject.DECEDUTO}`,
  keyIntNas: `subject-${CodeSubject.INT_NAS}`,
  keyIntNas2: `subject-${CodeSubject.INT_NAS2}`,
  keyIntNas2C1: `subject-${CodeSubject.INT_NAS2_C1}`,
  keyRichiedente: `subject-${CodeSubject.RICHIEDENTE}`,
  keyRichiedentePrivato: `subject-${CodeSubject.RICHIEDENTE_PRIVATO}`,
  keyProcPa: `subject-${CodeSubject.PROC_PA}`,
  keyProcMa: `subject-${CodeSubject.PROC_MA}`,
  keyConiuge: `subject-${CodeSubject.CONIUGE}`,
  keyUnitoCivilmente: `subject-${CodeSubject.UNITOCIVILMENTE}`,
  keyUniciv1: `subject-${CodeSubject.UNICIV1}`,
  keyUniciv2: `subject-${CodeSubject.UNICIV2}`,
  keyUniciv1Scio: `subject-${CodeSubject.UNICIV1_SCIO}`,
  keyUniciv2Scio: `subject-${CodeSubject.UNICIV2_SCIO}`,
  keyIntest: `subject-${CodeSubject.INTEST}`,
  keyTestimone3: `subject-${CodeSubject.TESTIMONE3}`,
  keyTestimone4: `subject-${CodeSubject.TESTIMONE4}`,
  keySposo: `subject-${CodeSubject.SPOSO}`,
  keyPadreSposo: `subject-${CodeSubject.PADRESPOSO}`,
  keyMadreSposo: `subject-${CodeSubject.MADRESPOSO}`,
  keyTutoreSposo: `subject-${CodeSubject.TUTORESPOSO}`,
  keyCuratoreSposo: `subject-${CodeSubject.CURATORESPOSO}`,
  keySposa: `subject-${CodeSubject.SPOSA}`,
  keyPadreSposa: `subject-${CodeSubject.PADRESPOSA}`,
  keyMadreSposa: `subject-${CodeSubject.MADRESPOSA}`,
  keyTutoreSposa: `subject-${CodeSubject.TUTORESPOSA}`,
  keyCuratoreSposa: `subject-${CodeSubject.CURATORESPOSA}`,
  keyAvvoc1: `subject-${CodeSubject.AVVOC1}`,
  keyAvvoc2: `subject-${CodeSubject.AVVOC2}`,
  keyAvvoc3: `subject-${CodeSubject.AVVOC3}`,
  keyAvvoc4: `subject-${CodeSubject.AVVOC4}`,
  keyAvvoc5: `subject-${CodeSubject.AVVOC5}`,
  keyAvvocUc1: `subject-${CodeSubject.AVVOCUC1}`,
  keyAvvocUc2: `subject-${CodeSubject.AVVOCUC2}`,
  keyFiglio: `subject-${CodeSubject.FIGLIO}`,
  keyOfficianteMatr: `subject-${CodeSubject.OFFICIANTE_MATR}`,
  keyIntest1: `subject-${CodeSubject.INTEST1}`,
  keyIntest2: `subject-${CodeSubject.INTEST2}`,
  keyIntAnn: `subject-${CodeSubject.INT_ANN}`,
};

export const KeySections = {
  keyDatiRegistroEmergenza: `section-${CodeSection.DATI_REGISTRO_EMERGENZA}`,
  keyDatiGenerali: `section-${CodeSection.DATI_GENERALI}`,
  keyDatiGen: `section-${CodeSection.DATI_GEN}`,
  keyDatiGeneraliConsAssRico: `section-${CodeSection.DATI_GENERALI_CONS_ASS_RICO}`,
  keyDatiGeneraliAssRico: `section-${CodeSection.DATI_GENERALI_ASS_RICO}`,
  keyDatiGeneraliAssRicoP: `section-${CodeSection.DATI_GENERALI_ASS_RICO_P}`,
  keyDatiGeneraliPresDoc: `section-${CodeSection.DATI_GENERALI_PRES_DOC}`,
  keyDatiGeneraliConsRico: `section-${CodeSection.DATI_GENERALI_CONS_RICO}`,
  keyDatiGeneraliConsRicoEvento: `section-${CodeSection.DATI_GENERALI_CONS_RICO_EVENTO}`,
  keyDatiGeneraliConsAssCognridRico: `section-${CodeSection.DATI_GENERALI_CONS_ASS_COGNRID_RICO}`,
  keyDatiGeneraliConsRicoSent: `section-${CodeSection.DATI_GENERALI_CONS_RICO_SENT}`,
  keyDatiGeneraliRiconoscimento: `section-${CodeSection.DATI_GENERALI_RICONOSCIMENTO}`,
  keyDatiGeneraliRicoGen: `section-${CodeSection.DATI_GENERALI_RICO_GEN}`,
  keyDatiGeneraliConsenso: `section-${CodeSection.DATI_GENERALI_CONSENSO}`,
  keyDatiGeneraliNegoz: `section-${CodeSection.DATI_GENERALI_NEGOZ}`,
  keyDatiDecesso: `section-${CodeSection.DATI_DECESSO}`,
  keyAutorizzazioneRiconoscimentoPadre: `section-${CodeSection.AUTORIZZAZIONE_RICONOSCIMENTO_PADRE}`,
  keyAutorizzazioneConsensoPadre: `section-${CodeSection.CONSENSO_PADRE}`,
  keyAutorizzazioneConsensoMadre: `section-${CodeSection.CONSENSO_MADRE}`,
  keyTipoMancatoConsMadre: `section-${CodeSection.TIPO_MANCATO_CONS_MADRE}`,
  keyGenitCheTrasmetteCit: `section-${CodeSection.GENIT_CHE_TRASMETTE_CIT}`,
  keyRicGenitoreItaliano: `section-${CodeSection.RIC_GENITORE_ITALIANO}`,
  keyDatiTrascrizione: `section-${CodeSection.DATI_TRASCRIZIONE}`,
  keyDatiTrascrizioneTpRichiedenteFg: `section-${CodeSection.DATI_TRASCRIZIONE_TP_RICHIEDENTE_FG}`,
  keyDatiTrascrizioneTpRichiedente: `section-${CodeSection.DATI_TRASCRIZIONE_TP_RICHIEDENTE}`,
  keyDatiTrascrizioneSeparazione: `section-${CodeSection.DATI_TRASCRIZIONE_SEPARAZIONE}`,
  keyDatiTrascrizioneMatrimonio: `section-${CodeSection.DATI_TRASCRIZIONE_MATRIMONIO}`,
  keyDatiTrascrizioneRichiedente: `section-${CodeSection.DATI_TRASCRIZIONE_RICHIEDENTE}`,
  keyDatiMatrimonio: `section-${CodeSection.DATI_MATRIMONIO}`,
  keySentenzaPaternita: `section-${CodeSection.SENTENZA_PATERNITA}`,
  keyEstremiSentenzaMadre: `section-${CodeSection.ESTREMI_SENTENZA_MADRE}`,
  keyEstremiSentenzaPadre: `section-${CodeSection.ESTREMI_SENTENZA_PADRE}`,
  keyAttoCollegato: `section-${CodeSection.ATTO_COLLEGATO}`,
  keyCittadinanzaAttoNascita: `section-${CodeSection.CITTADINANZA_ATTO_NASCITA}`,
  keyAttoConsensoAtcom: `section-${CodeSection.ATTO_CONSENSO_ATCOM}`,
  keyAttoConsensoAtcop: `section-${CodeSection.ATTO_CONSENSO_ATCOP}`,
  keyAttoDiConsensoAtco: `section-${CodeSection.ATTO_DI_CONSENSO_ATCO}`,
  keyAttoDiConsensoAtcoP: `section-${CodeSection.ATTO_DI_CONSENSO_ATCOP}`,
  keyAttoDiConsensoEd: `section-${CodeSection.ATTO_DI_CONSENSO_ED}`,
  keyAttoDaRettificare: `section-${CodeSection.ATTO_DA_RETTIFICARE}`,
  keyConsensoSentenza: `section-${CodeSection.CONSENSO_SENTENZA}`,
  keySentenzaConsenso: `section-${CodeSection.SENTENZA_CONSENSO}`,
  keyAttoAssensoFiglio: `section-${CodeSection.ATTO_ASSENSO_FIGLIO}`,
  keyAttoAssensoFiglioReso: `section-${CodeSection.ATTO_ASSENSO_FIGLIO_RESO}`,
  keyAssensoFiglio: `section-${CodeSection.ASSENSO_FIGLIO}`,
  keyDatiSpecificiCittadinanza: `section-${CodeSection.DATI_SPECIFICI_CITTADINANZA}`,
  keyDatiEventoCittadinanza: `section-${CodeSection.DATI_EVENTO_CITTADINANZA}`,
  keyDatiTrascrizioneCittadinanza: `section-${CodeSection.DATI_TRASCRIZIONE_CITTADINANZA}`,
  keyTrascrizioneCittadinanza: `section-${CodeSection.TRASCRIZIONE_CITTADINANZA}`,
  keyTrascrizioneNascita: `section-${CodeSection.TRASCRIZIONE_NASCITA}`,
  keyAttoNascitaConiuge: `section-${CodeSection.ATTO_NASCITA_CONIUGE}`,
  keyAttoMatrimonio: `section-${CodeSection.ATTO_MATRIMONIO}`,
  keyAttoUnioneCivile: `section-${CodeSection.ATTO_UNIONE_CIVILE}`,
  keyAttoNascitaUnito: `section-${CodeSection.ATTO_NASCITA_UNITO}`,
  keyMatrimonioAtto: `section-${CodeSection.MATRIMONIO_ATTO}`,
  keyMatrimonioAttoNascitaSposo: `section-${CodeSection.MATRIMONIO_ATTO_NASCITA_SPOSO}`,
  keyMatrimonioAttoNascitaSposa: `section-${CodeSection.MATRIMONIO_ATTO_NASCITA_SPOSA}`,
  keyMatrimonioAttoNascitaFiglio: `section-${CodeSection.MATRIMONIO_ATTO_NASCITA_FIGLIO}`,
  keyMorteAttoNascitaDeceduto: `section-${CodeSection.MORTE_ATTO_NASCITA_DECEDUTO}`,
  keyDatiRiconciliazione: `section-${CodeSection.DATI_RICONCILIAZIONE}`,
  keyAttoRiconoscimento: `section-${CodeSection.ATTO_RICONOSCIMENTO}`,
  keyAttoRiconoscimentoMadre: `section-${CodeSection.ATTO_RICONOSCIMENTO_MADRE}`,
  keyAttoRiconoscimentoPadre: `section-${CodeSection.ATTO_RICONOSCIMENTO_PADRE}`,
  keyAnnotazioneContestuale: `section-${CodeSection.ANNOTAZIONE_CONTESTUALE}`,
  keyDatiProvcom: `section-${CodeSection.DATI_PROVCOM}`,
  keyDatiSpecificiUniciv: `section-${CodeSection.DATI_SPECIFICI_UNICIV}`,
  keyDatiSpecificiMatr: `section-${CodeSection.DATI_SPECIFICI_MATR}`,
  keyProvvedimentoEstinzioneOpposizione: `section-${CodeSection.PROVVEDIMENTO_ESTINZIONE_OPPOSIZIONE}`,
  keyProvvedimentoRigettoOpposizione: `section-${CodeSection.PROVVEDIMENTO_RIGETTO_OPPOSIZIONE}`,
  keyCertImpedimentoGenerico: `section-${CodeSection.CERT_IMPEDIMENTO_GENERICO}`,
  keyRegimePatrimoniale: `section-${CodeSection.REGIME_PATRIMONIALE}`,
  keyCertImpedimentoGenericoSposo: `section-${CodeSection.CERT_IMPEDIMENTO_SPOSO}`,
  keyCertImpedimentoGenericoSposa: `section-${CodeSection.CERT_IMPEDIMENTO_SPOSA}`,
  keyPubblicazione1: `section-${CodeSection.PUBBLICAZIONE_1}`,
  keyPubblicazione2: `section-${CodeSection.PUBBLICAZIONE_2}`,
  keyMatrimonioSentenzaOmissionePubblicazione: `section-${CodeSection.MATRIMONIO_SENTENZA_OMISSIONE_PUBBLICAZIONE}`,
  keyMatrimonioNominaAssistenteLegaleSposo: `section-${CodeSection.MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSO}`,
  keyMatrimonioNominaAssistenteLegaleSposa: `section-${CodeSection.MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSA}`,
  keyMatrimonioAutorizzazioneDifettoEta: `section-${CodeSection.MATRIMONIO_AUTORIZZAZIONE_DIFETTO_ETA}`,
  keyMatrimonioAutorizzazioneDivietoTemp: `section-${CodeSection.MATRIMONIO_AUTORIZZAZIONE_DIVIETO_TEMP}`,
  keyMatrimonioAutorizzazioneParentela: `section-${CodeSection.MATRIMONIO_AUTORIZZAZIONE_PARENTELA}`,
  keyMatrimonioNominaAssistenzaLegaleSposo: `section-${CodeSection.MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSO}`,
  keyMatrimonioNominaAssistenzaLegaleSposa: `section-${CodeSection.MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSA}`,
  keyDatiAccertamento: `section-${CodeSection.DATI_ACCERTAMENTO}`,
  keyDatiSepar: `section-${CodeSection.DATI_SEPAR}`,
  keyDatiSeparUC: `section-${CodeSection.DATI_SEPARUC}`,
  keyProvvedimentoSeparazione: `section-${CodeSection.PROVVEDIMENTO_SEPARAZIONE}`,
  keyAccordoSeparazione: `section-${CodeSection.ACCORDO_SEPARAZIONE}`,
  keyConfermaAccordoSep: `section-${CodeSection.CONFERMA_ACCORDO_SEP}`,
  keyDatiAutoritaMittente: `section-${CodeSection.DATI_AUTORITA_MITTENTE}`,
  keyConsensoAltro: `section-${CodeSection.CONSENSO_ALTRO}`,
  keyConsensoAtto: `section-${CodeSection.CONSENSO_ATTO}`,
  keyNegoziazioneAssistita: `section-${CodeSection.NEGOZIAZIONE_ASSISTITA}`,
  keyUnioneCivileAttoNascitaConiuge1: `section-${CodeSection.UNIONE_CIVILE_ATTO_NASCITA_CONIUGE1}`,
  keyUnioneCivileAttoNascitaConiuge2: `section-${CodeSection.UNIONE_CIVILE_ATTO_NASCITA_CONIUGE2}`,
  keyAttoNascitaFiglio: `section-${CodeSection.ATTO_NASCITA_FIGLIO}`,
  keyRicAtto: `section-${CodeSection.RIC_ATTO}`,
  keyScioglimentoAttoUnioneCivile: `section-${CodeSection.SCIOGLIMENTO_ATTO_UNIONE_CIVILE}`,
};
